import React from "react";
class Index extends React.Component {
  render() {
    return null;
  }
}
export default Index;
